import { SVGProps } from 'react';

const YoutubeIcon = ({ viewBox = '0 0 20 20', ...props }: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} fill="none" {...props}>
    <path
      fill="currentColor"
      d="m8.2 13.5 4.671-2.7L8.2 8.1v5.4Zm10.404-7.047c.117.423.198.99.252 1.71.063.72.09 1.341.09 1.881L19 10.8c0 1.971-.144 3.42-.396 4.347-.225.81-.747 1.332-1.557 1.557-.423.117-1.197.198-2.385.252-1.17.063-2.241.09-3.231.09L10 17.1c-3.771 0-6.12-.144-7.047-.396-.81-.225-1.332-.747-1.557-1.557-.117-.423-.198-.99-.252-1.71-.063-.72-.09-1.341-.09-1.881L1 10.8c0-1.971.144-3.42.396-4.347.225-.81.747-1.332 1.557-1.557.423-.117 1.197-.198 2.385-.252 1.17-.063 2.241-.09 3.231-.09L10 4.5c3.771 0 6.12.144 7.047.396.81.225 1.332.747 1.557 1.557Z"
    />
  </svg>
);
export default YoutubeIcon;
